import Backbone from 'backbone';
import { BackboneViewProps } from '../../types';

const $ = require('jquery');
const template = require('./googlesheet.pug');

function highlight(subclass: string) {
  $('.sidebar__nav *').removeClass('active');
  $(`li.sidebar__nav--${subclass}`).addClass('active');
}

export default (Backbone as any).Epoxy.View.extend({
  events: {
    'click #go-integrations': 'go_integrations',
    'click #go-profiles': 'go_profiles',
    'click #go-predictions': 'go_predictions',
    'click #copy_clip_btn': 'copy_API_clipboard',
  },

  go_integrations() {
    highlight('integrations');
    Backbone.history.navigate(
      `/org/${this.tenant}/integrations/list/all`,
      true
    );
  },
  go_predictions() {
    highlight('predictions');
    Backbone.history.navigate(`/org/${this.tenant}/predictions`, true);
  },

  go_profiles() {
    highlight('profiles');
    Backbone.history.navigate(`/org/${this.tenant}/profiles`, true);
  },

  async initialize(paramOptions: BackboneViewProps) {
    const options = paramOptions || {};
    this.tenant = options.tenant || this.tenant;
    this.model.fetch({ success: () => this.render() });
  },

  copy_API_clipboard() {
    const result = this.model.attributes.api_key;
    const fake_area = document.createElement('textarea');
    document.body.appendChild(fake_area);
    fake_area.value = result;
    fake_area.select();
    document.execCommand('copy');
    document.body.removeChild(fake_area);
  },

  render() {
    this.copy_API_clipboard();
    const html = $(
      '#tpl_main',
      template({
        tenant: this.tenant,
        API_key: this.model.attributes.api_key,
        url: this.sheet_url,
      })
    ).html();
    this.$el.html(html);
    $('.carousel', this.$el).carousel();
    this.currentSlide = 0;
    return this;
  },
});
